const STORAGE_KEY = "virdio_active_session";
const HEARTBEAT_INTERVAL = 3000;

class CrashRecoveryService {
  constructor() {
    this.heartbeatInterval = null;
    this.stressInterval = null;
    this.canvasInterval = null;
    this.memoryHog = [];
    console.log("CrashService: Service Initialized");
  }

  // wasLastSessionCrash() {
  //   const navEntries = performance.getEntriesByType("navigation");
  //   const navigationType = navEntries.length > 0 ? navEntries[0].type : "unknown";
  //   const savedData = sessionStorage.getItem(STORAGE_KEY);

  //   console.log(`CrashService: Checking session. NavType: ${navigationType}`);

  //   if (savedData) {
  //     const { timestamp, status } = JSON.parse(savedData);
  //     const age = Date.now() - timestamp;
      
  //     console.log(`CrashService: Found saved session. Status: ${status}, Age: ${(age/1000).toFixed(1)}s`);

  //     if (status === 'active' && navigationType === 'navigate' && age < 20000) {
  //       console.warn("CrashService: CRASH DETECTED: Previous session was active but interrupted.");
  //       return true; 
  //     } else {
  //       console.log("CrashService: No crash detected. Session was either completed or too old.");
  //       sessionStorage.removeItem(STORAGE_KEY);
  //     }
  //   } else {
  //     console.log("CrashService: No previous session data found in storage."); 
  //   }
  //   return false;
  // }

  wasLastSessionCrash() {
    const navEntries = performance.getEntriesByType("navigation");
    if (navEntries.length === 0) return false;

    const navType = navEntries[0].type; // 'navigate', 'reload', 'back_forward', or 'prerender'
    const savedData = sessionStorage.getItem(STORAGE_KEY);

    console.log(`CrashService: Checking session. NavType: ${navType}`);
    // FIX 1: If the user manually RELOADED or hit BACK, it's not a crash.
    if (navType === 'back_forward') {
        console.log("CrashService: User action (back) detected. Not a crash.");
        sessionStorage.removeItem(STORAGE_KEY);
        return false;
    }

    if (savedData) {
        const { timestamp, status } = JSON.parse(savedData);
        const age = Date.now() - timestamp;

        // LOOP BREAKER: If the user clicked X or Reload, status will be 'intentional_exit'
        if (status === 'intentional_exit') {
            console.log("CrashService: Intentional action detected. Cleaning up.");
            sessionStorage.removeItem(STORAGE_KEY);
            return false;
        }

        // FIX 2: Only trigger if the session was 'active' AND it's a 'navigate'
        // AND the timestamp is very recent.
        // If the user closed the tab and came back 5 minutes later, it's not a crash.
        if (status === 'active' && age < 15000) {
            console.warn("CrashService: CRASH DETECTED");
            return true; 
        } 

        // If we got here, it's a false positive or an old session. Clear it.
        sessionStorage.removeItem(STORAGE_KEY);
    }
    return false;
}

  startHeartbeat() {
    this.stopHeartbeat();
    console.log("CrashService: Starting Heartbeat...");

    const update = () => {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        status: 'active'
      }));
    };
    
    update();
    this.heartbeatInterval = setInterval(update, HEARTBEAT_INTERVAL);
  }

  stopHeartbeat(graceful = false) {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
      console.log("CrashService: Heartbeat Paused/Stopped.");
    }
    if (graceful) {
      console.log("CrashService: Marking session as 'completed' (Graceful Exit).");
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        status: 'completed'
      }));
    }
  }

  startStressTest() {
    console.warn("STRESS_TEST: ACTIVATED. Pushing memory and GPU limits...");
    
    this.stressInterval = setInterval(() => {
      try {
        for (let i = 0; i < 5; i++) {
          this.memoryHog.push(new Array(1024 * 1024).fill(Math.random()));
        }
        if (this.memoryHog.length % 50 === 0) {
           console.log(`STRESS_TEST: Allocated ~${this.memoryHog.length}MB of RAM...`);
        }
      } catch (e) {
        console.error("STRESS_TEST: Memory Allocation Failed! Browser out of RAM:", e.message);
      }
    }, 100);

    const canvas = document.createElement('canvas');
    canvas.width = 2000; canvas.height = 2000;
    const ctx = canvas.getContext('2d');
    
    this.canvasInterval = setInterval(() => {
      ctx.createImageData(2000, 2000); // Heavy GPU/RAM task
    }, 50);
  }

  stopStressTest() {
    if (this.stressInterval || this.canvasInterval) {
      clearInterval(this.stressInterval);
      clearInterval(this.canvasInterval);
      this.memoryHog = [];
      console.log("STRESS_TEST: Deactivated. Memory released.");
    }
  }

  handleIntentionalExit() {
      const savedData = sessionStorage.getItem(STORAGE_KEY);
      if (savedData) {
        const data = JSON.parse(savedData);
        data.status = 'intentional_exit'; 
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      }
    };

  clearSession() {
      console.log("CrashService: Intentional exit, clearing session.");
      sessionStorage.removeItem(STORAGE_KEY);
  }
}

export default new CrashRecoveryService();